import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const configModule = {
  namespaced: true,
  state: {
    lit: '',
    jwt: ''
  },
  mutations: {
    update (state, args) {
      let keys = Object.keys(args)
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i]
        if (key in state) {
          state[key] = args[key]
        }
      }
    }
  },
  getters: {
    get: (state) => (type) => {
      return (type in state) ? state[type] : null
    }
  }
}

const userModule = {
  namespaced: true,
  state: {
    id: '',
    type: '',
    author: {
      id: '',
      name: ['', '']
    },
    name: ['', ''],
    kana: ['', ''],
    lib: {
      shared: ''
    }
  },
  mutations: {
    update (state, req) {
      if ('id' in req) {
        state.id = req.id
      }
      if ('type' in req) {
        state.type = req.type
      }
      if ('author' in req) {
        if ('id' in req.author) {
          state.author.id = req.author.id
        }
        if ('name' in req.author) {
          state.author.name.splice(0, 1, (req.author.name.length > 0) ? req.author.name[0] : '')
          state.author.name.splice(1, 1, (req.author.name.length > 1) ? req.author.name[1] : '')
        }
      }
      if ('name' in req) {
        state.name.splice(0, 1, (req.name.length > 0) ? req.name[0] : '')
        state.name.splice(1, 1, (req.name.length > 1) ? req.name[1] : '')
      }
      if ('kana' in req) {
        state.kana.splice(0, 1, (req.kana.length > 0) ? req.kana[0] : '')
        state.kana.splice(1, 1, (req.kana.length > 1) ? req.kana[1] : '')
      }
      if ('lib' in req) {
        if ('shared' in req.lib) {
          state.lib.shared = req.lib.shared
        }
      }
    }
  },
  getters: {
    get: (state) => (type) => {
      return (type in state) ? state[type] : null
    },
    all: (state) => () => {
      return state
    }
  }
}

const loaderModule = {
  namespaced: true,
  state: {
    status: {
      active: false
    },
    message: {
      default: 'データの読み込み中...',
      value: ''
    }
  },
  mutations: {
    open (state, msg) {
      state.message.value = (msg == null) ? state.message.default : msg
      state.status.active = true
    },
    close (state) {
      state.status.active = false
    },
    set (state, msg) {
      state.message.value = msg
    }
  },
  getters: {
    isActive: (state) => () => {
      return state.status.active
    },
    printMessage: (state) => () => {
      return state.message.value
    }
  }
}

const notifierModule = {
  namespaced: true,
  state: {
    items: []
  },
  mutations: {
    add (state, item) {
      state.items.push({
        id: item.id,
        type: item.type ? item.type : '',
        title: item.title ? item.title : '無題',
        message: item.message ? item.message : '',
        progress: item.progress ? item.progress : 0
      })
    },
    update (state, item) {
      if (item.id) {
        let idx = state.items.findIndex(it => {
          return it.id && it.id === item.id
        })
        if (idx >= 0) {
          if ('type' in item) {
            state.items[idx].type = item.type
          }
          if ('title' in item) {
            state.items[idx].title = item.title
          }
          if ('message' in item) {
            state.items[idx].message = item.message
          }
          if ('progress' in item) {
            state.items[idx].progress = item.progress
          }
        }
      }
    },
    close (state, id) {
      let idx = state.items.findIndex(it => {
        return (it.id && it.id === id)
      })
      state.items.splice(idx, 1)
    }
  },
  actions: {
    addSMessage (context, item) {
      let uid = new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)
      context.commit('add', Object.assign({}, item, {
        id: uid,
        type: 'message'
      }))
      setTimeout(() => {
        context.commit('close', uid)
      }, 3000)
    },
    addAlert (context, item) {
      let uid = new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)
      context.commit('add', Object.assign({}, item, {
        id: uid,
        type: 'alert'
      }))
      setTimeout(() => {
        context.commit('close', uid)
      }, 5000)
    },
    addMessage (context, item) {
      let uid = new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)
      context.commit('add', Object.assign({}, item, {
        id: uid,
        type: 'message'
      }))
      setTimeout(() => {
        context.commit('close', uid)
      }, 10000)
    },
    addProgress (context, item) {
      let uid = item.id ? item.id : new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)
      context.commit('add', Object.assign({}, item, {
        id: uid,
        type: 'progress'
      }))
    },
    updateProgress (context, item) {
      context.commit('update', item)
    },
    closeProgress (context, id) {
      context.commit('close', id)
    }
  },
  getters: {
    list: (state) => () => {
      return state.items
    }
  }
}

export default new Vuex.Store({
  modules: {
    config: configModule,
    user: userModule,
    loader: loaderModule,
    notifier: notifierModule
  }
})
